var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as Avatar from '../Avatar';
import { Title } from './Title';
import { Body } from './Body';
import { View } from './View';
export var Resource = function (_a) {
    var resourceDocument = _a.resourceDocument, view = __rest(_a, ["resourceDocument"]);
    return (React.createElement(View, __assign({}, view),
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "mr-2" },
                React.createElement(Avatar.Simple, { name: resourceDocument.title, maxInitials: 1, color: resourceDocument.color, imageUrl: resourceDocument.iconUrl })),
            React.createElement("div", { className: "flex flex-col my-auto" },
                React.createElement(Title, null, resourceDocument.title),
                React.createElement(Body, null, resourceDocument.excerpt)))));
};
Resource.displayName = 'Card.Resource';
